import React, { useState } from 'react'
import injectSheet from 'react-jss'
import styles from './slide-form.styles'
import { ModalContent } from 'pobble-components/dist/modal'
import FormRow from '../../../common/form-elements/form-row/form-row'
import FormInput from 'pobble-components/dist/form-elements/form-input'
import FormTextArea from 'pobble-components/dist/form-elements/form-text-area'
import FormLabel from 'pobble-components/dist/form-elements/form-label'
import CharactersCount from 'pobble-components/dist/form-elements/characters-count'
import FormRadio from 'pobble-components/dist/form-elements/form-radio'
import THEME from 'pobble-components/dist/theme'
import ColorSelect from '../../../color-select/color-select'

const TITLE_MAX_LENGTH = 100

const { COLORS } = THEME

const colors = [
  COLORS.PURPLE.NORMAL,
  COLORS.BLUE.NORMAL,
  COLORS.GREEN.NORMAL,
  COLORS.DARK_BLUE.NORMAL
]

const titlePlaceholders = [
  'e.g. Adjectives',
  'e.g. Openers',
  'e.g. Wow words',
  'e.g. Adverbs'
]

const colorsOptions = colors.map(color => ({
  color,
  value: color
}))

const SlideForm = ({
  classes,
  initialValues = {
    bank: [
      {
        words: '',
        title: '',
        color: colors[0]
      },
      {
        words: '',
        title: '',
        color: colors[1]
      },
      {
        words: '',
        title: '',
        color: colors[2]
      }
    ],
    title: ''
  },
  footer,
  onSubmit
}) => {
  const [bankHistory, setBankHistory] = useState(initialValues.bank)
  const [bank, setBank] = useState(initialValues.bank)
  const [title, setTitle] = useState(initialValues.title)

  const setAmountOfGroups = e => {
    const n = parseInt(e.target.value)
    if (n === bank.length) return
    setBankHistory([...Array(4).keys()].map(i => bank[i] || bankHistory[i]))
    if (n < bank.length) {
      setBank(bank.slice(0, n))
    } else {
      setBank(
        [...Array(n).keys()].map(
          i =>
            bank[i] ||
            bankHistory[i] || { words: '', title: '', color: colors[i] }
        )
      )
    }
  }

  return (
    <form
      className="metrics__slide-form"
      onSubmit={e => {
        e.preventDefault()
        onSubmit({ title, bank })
      }}>
      <ModalContent legacy className={classes.content}>
        <FormLabel small spaceBetween htmlFor="title">
          Title of the slide
          <CharactersCount value={title} max={TITLE_MAX_LENGTH} />
        </FormLabel>
        <FormRow first>
          <FormInput
            autoFocus
            required
            maxLength={TITLE_MAX_LENGTH}
            placeholder="e.g. Word Bank"
            id="title"
            value={title}
            onChange={e => setTitle(e.target.value)}
          />
        </FormRow>
        <FormRow className={classes.groupsRadioRow}>
          <FormLabel small>Chose number of word groups</FormLabel>
          <div className={classes.groupsRadioHolder}>
            <div className={classes.groupRadio}>
              <FormRadio
                value={1}
                onChange={setAmountOfGroups}
                checked={bank.length === 1}
                id="oneGroup"
                name="groups"
              />
              <FormLabel htmlFor="oneGroup" gapLeft>
                One
              </FormLabel>
            </div>
            <div className={classes.groupRadio}>
              <FormRadio
                value={2}
                onChange={setAmountOfGroups}
                checked={bank.length === 2}
                id="twoGroups"
                name="groups"
              />
              <FormLabel htmlFor="twoGroups" gapLeft>
                Two
              </FormLabel>
            </div>
            <div className={classes.groupRadio}>
              <FormRadio
                value={3}
                onChange={setAmountOfGroups}
                checked={bank.length === 3}
                id="threeGroups"
                name="groups"
              />
              <FormLabel htmlFor="threeGroups" gapLeft>
                Three
              </FormLabel>
            </div>
            <div className={classes.groupRadio}>
              <FormRadio
                value={4}
                onChange={setAmountOfGroups}
                checked={bank.length === 4}
                id="fourGroups"
                name="groups"
              />
              <FormLabel htmlFor="fourGroups" gapLeft>
                Four
              </FormLabel>
            </div>
          </div>
        </FormRow>
        <div
          className={classes.groups}
          style={{
            gridTemplateColumns: `repeat(${bank.length}, 1fr)`
          }}>
          {bank.map((group, index) => {
            return (
              <div key={index}>
                {bank.length > 1 && (
                  <>
                    <FormLabel small>Group {index + 1}</FormLabel>
                    <FormRow first>
                      <FormInput
                        onChange={e => {
                          const bankCopy = [...bank]
                          bankCopy[index].title = e.target.value
                          setBank(bankCopy)
                        }}
                        value={bank[index].title}
                        placeholder={titlePlaceholders[index]}
                        name="title"
                      />
                    </FormRow>
                  </>
                )}
                <FormRow first={bank.length === 1}>
                  {bank.length === 1 && <FormLabel small>Words:</FormLabel>}
                  <FormTextArea
                    required
                    value={bank[index].words}
                    onChange={e => {
                      const bankCopy = [...bank]
                      bankCopy[index].words = e.target.value
                      setBank(bankCopy)
                    }}
                    placeholder="Type here, use commas to create new blocks"
                  />
                </FormRow>
                <FormRow>
                  <ColorSelect
                    className={classes.colorSelect}
                    onChange={({ value }) => {
                      const bankCopy = [...bank]
                      bankCopy[index].color = value
                      setBank(bankCopy)
                    }}
                    value={bank[index].color}
                    options={colorsOptions}
                  />
                </FormRow>
              </div>
            )
          })}
        </div>
      </ModalContent>
      {footer(bank)}
    </form>
  )
}

export default injectSheet(styles)(SlideForm)
